import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// utils.js ou utils.ts

export const formatDate = (value) => {
  if (!value) return "";

  try {
    // Garante que estamos lidando com string
    const str = typeof value === "string" ? value : value.toString().trim();

    // Se a data não tiver timezone, forçamos como UTC adicionando 'Z'
    const iso = str.endsWith("Z") ? str : `${str}Z`;

    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return "";
    }

    // O navegador converte de UTC para o fuso local automaticamente
    return date.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (err) {
    console.error("Erro ao formatar data:", err);
    return "";
  }
};

export const getStatusColor = (status) => {
  const colors = {
    'Aberto': 'bg-blue-500',
    'Em Andamento': 'bg-yellow-500',
    'Encerrado': 'bg-green-500',
    'Cancelado': 'bg-red-500',
  };
  return colors[status] || 'bg-gray-500';
};

export const getPriorityColor = (priority) => {
  const colors = {
    'Baixa': 'bg-gray-500',
    'Media': 'bg-blue-500',
    'Alta': 'bg-orange-500',
    'Urgente': 'bg-red-500',
  };
  return colors[priority] || 'bg-gray-500';
};
